<template>
    <div class="page-static" v-if="isPageExists(pageMap)" v-html="pageMap[type].body">
    </div>
</template>

<script>

import { mapState } from 'vuex';

export default {
    props: ['type'],
    computed: {
        ...mapState({
            pageMap: state => state.cms.map
        }),
    },
    methods: {
        isPageExists(map) {
            return map[this.type];
        }
    },
    watch: {
        type: function () {
            this.$store.dispatch('cms/getFullPage', this.type);
        }
    },
    beforeMount() {
        this.$store.dispatch('cms/getFullPage', this.type);
    }
}
</script>



// WEBPACK FOOTER //
// src/components/cms/src/Page.vue